import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Company from './icon-company.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Company {...validProps} />;
}
SvgComponent.iconName = 'company';

/**
 * @deprecated This is a legacy icon
 */
export const CompanyIcon = svgIconWrapper(SvgComponent);
